/** Single switch for all local demo data across Dashboard / Candidates / Interviews / Positions / Analytics. */
export const USE_DEMO_DATA = false;
